module.exports = __webpack_public_path__ + "static/cornell-45b8110e8bcc58dfd476f0415329b6ec.svg";